import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'app-print-tab',
  templateUrl: './print-tab.component.html',
  styleUrls: ['./print-tab.component.scss']
})
export class PrintTabComponent implements OnInit {

  filteredProducts;
  items;
  pages;
  pageNumber;
  maxItems;
  hasItems;
  pageHeader;
  noPages = false;

  pageLayout = 'half-page-letter-no-colors';

  constructor(public shared: Shared) { 
    this.filterProducts();
    this.constructMaxItems();
    this.constructPages();
  }

  ngOnInit() {

  }

  filterProducts(){
    this.filteredProducts = this.shared.products.filter(product => {
      return product.locations[this.shared.firebase_user.location];
    })
    console.log("STEP 1:", this.filteredProducts);

    this.filteredProducts.forEach(product => {
      console.log(product.name + ": " + product.type);
    })
  }

  constructMaxItems(){
    switch(this.pageLayout){
      case 'half-page-letter-no-colors':
        this.maxItems = 7;
        break;
      default:
        console.log('max items error');
    }
  }

  constructPages(){   
    this.noPages = false;
    this.pageNumber = (this.filteredProducts.length / this.maxItems);
    if((this.pageNumber % 2) !== 0){
      this.pageNumber = Math.ceil(this.pageNumber);
    }
    if(this.pageNumber === 0){
      this.noPages = true;
    }
    this.pages = Array.from({length: this.pageNumber}, (x, i) => i);
    //console.log(this.maxItems, this.pages);

  }

  printMenu(){
    window.print();
  }

  

}



// WEBPACK FOOTER //
// ./src/app/print-tab/print-tab.component.ts